'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$14(evaluator$15) {
  this.Lapp_data_AppRegisteredUser$$anon$14__f_evaluator$5 = null;
  this.Lapp_data_AppRegisteredUser$$anon$14__f_evaluator$5 = evaluator$15;
}
export { $c_Lapp_data_AppRegisteredUser$$anon$14 as $c_Lapp_data_AppRegisteredUser$$anon$14 };
$c_Lapp_data_AppRegisteredUser$$anon$14.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$14.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$14;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$14() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$14 as $h_Lapp_data_AppRegisteredUser$$anon$14 };
$h_Lapp_data_AppRegisteredUser$$anon$14.prototype = $c_Lapp_data_AppRegisteredUser$$anon$14.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$14.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$14.prototype.apply__s_Option = (function() {
  var v = this.Lapp_data_AppRegisteredUser$$anon$14__f_evaluator$5.apply__O();
  return (((typeof v) === "boolean") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_data_AppRegisteredUser$$anon$14.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_data_AppRegisteredUser$$anon$14 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$14, "app.data.AppRegisteredUser$$anon$14", ({
  Lapp_data_AppRegisteredUser$$anon$14: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$14 as $d_Lapp_data_AppRegisteredUser$$anon$14 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$14.js.map
